/** Natural sort comparator — "1-intro" < "2-patterns" < "10-final" */
export function naturalCompare(a, b) {
  const ax = (a || "").toString();
  const bx = (b || "").toString();
  const re = /(\d+)|(\D+)/g;
  const ap = ax.match(re) || [];
  const bp = bx.match(re) || [];
  for (let i = 0; i < Math.max(ap.length, bp.length); i++) {
    if (i >= ap.length) return -1;
    if (i >= bp.length) return 1;
    const an = parseInt(ap[i], 10);
    const bn = parseInt(bp[i], 10);
    if (!isNaN(an) && !isNaN(bn)) {
      if (an !== bn) return an - bn;
    } else {
      const cmp = ap[i].localeCompare(bp[i], undefined, { sensitivity: "base" });
      if (cmp !== 0) return cmp;
    }
  }
  return 0;
}

export function sortByName(items, nameKey = "name") {
  return [...items].sort((a, b) => naturalCompare(a[nameKey] || a.original_filename || "", b[nameKey] || b.original_filename || ""));
}
